import React, { FC, useEffect, useState } from 'react';
import { GiftShopDeliverySend } from './gift-shop-delivery-send';
import {
    GiftShopType,
    IFlowPickup,
    IFlowSend,
    IGiftShopDeliveryPickupModel,
    IGiftShopDeliverySendModel,
    IGiftShopToBasketBundle,
} from '$models';

type Props = {
    onSubmit?: (values: IFlowSend | IFlowPickup) => void;
    flowData?: IGiftShopToBasketBundle;
    editStep?: boolean;
    onCloseModal?: () => void;
};

export const GiftShopDelivery: FC<Props> = ({ flowData, editStep, onSubmit, onCloseModal }): JSX.Element => {
    const [giftShopDeliverySendModel, setGiftShopDeliverySendModel] = useState<IGiftShopDeliverySendModel>();

    useEffect(() => {
        if (flowData && editStep) {
            if (flowData.giftDetails?.deliveryDate) {
                setGiftShopDeliverySendModel({
                    name: flowData?.giftDetails?.deliveryAddress?.name || undefined,
                    companyName: flowData?.giftDetails?.deliveryAddress?.companyName || undefined,
                    address: flowData?.giftDetails?.deliveryAddress?.streetAndNumber || undefined,
                    zipcode: flowData?.giftDetails?.deliveryAddress?.zip || undefined,
                    city: flowData?.giftDetails?.deliveryAddress?.city || undefined,
                    deliveryDate: flowData?.giftDetails?.deliveryDate ? flowData?.giftDetails?.deliveryDate : undefined,
                    storeId: flowData?.giftDetails?.storeId || undefined,
                    phoneNumber: flowData?.giftDetails?.deliveryAddress?.phoneNumber || undefined,
                    occasion: flowData?.giftDetails?.occasion || undefined,
                });
            }
        }
    }, [flowData]);

    const getGiftShopDeliveryModel = (model: IGiftShopDeliveryPickupModel | IGiftShopDeliverySendModel) => {
        return {
            kind: GiftShopType.Send,
            ...model,
        };
    };

    return (
        <GiftShopDeliverySend
            onSubmitDelivery={(value) => onSubmit?.(getGiftShopDeliveryModel(value))}
            deliveryInfo={giftShopDeliverySendModel}
            editStep={editStep}
            onCloseModal={() => onCloseModal?.()}
        />
    );
};
